import React from "react";
import ReactECharts from "echarts-for-react";
import { graphic } from "echarts";

function Chart({
  lineColor,
  axisColorOne,
  axisColorTwo,
  days,
  values,
  labelName,
}) {
  const option = {
    backgroundColor: "transparent",
    xAxis: {
      axisLine: {
        show: false,
        lineStyle: {
          color: "#D9D9D9",
        },
        textStyle: {
          color: "#ffffff",
          fontFamily: "Saira Semi Condensed",
        },
      },
      splitLine: {
        show: false,
        lineStyle: {
          color: "#4B4F6D",
        },
      },
      data: days,
    },
    yAxis: {
      type: "value",
      axisLine: {
        lineStyle: {
          color: "transparent",
        },
      },
      splitLine: {
        show: false,
        lineStyle: {
          color: "#4B4F6D",
        },
      },
      min: function (value) {
        return value.min;
      },
      // min: 0,
      // max: 150,
      max: function (value) {
        return value.max;
      },

      axisLabel: {
        formatter: function (value) {
          return value;
          // return value + "k";
        },
      },
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "10%",
      //   top: "15%",
      containLabel: true,
    },
    tooltip: {
      trigger: "axis",
      backgroundColor: "#212325",
      textStyle: {
        color: "#ffffff", // Set the text color of the tooltip
        fontFamily: "Saira Semi Condensed",
        fontWeight: "400",
      },

      axisPointer: {
        show: false,
        type: "line",
        lineStyle: {
          color: "transparent",
          //   color: "#4B4F6D",
        },
      },
    },
    // dataZoom: [
    //   {
    //     type: "inside",
    //   },
    // ],

    series: [
      {
        name: labelName,
        type: "line",
        stack: "Total",
        emphasis: {
          focus: "series",
        },
        color: lineColor,

        areaStyle: {
          color: new graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: axisColorOne,
            },
            {
              offset: 1,
              color: axisColorTwo,
            },
          ]),
        },
        data: values,
      },
    ],
  };
  return (
    <>
      <ReactECharts
        style={{
          width: "100%",
          height: "100%",
        }}
        option={option}
      />
    </>
  );
}

export default Chart;
